import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  purchase: []
};

const slice = createSlice({
  name: 'pos',
  initialState,
  reducers: {
    setPurchaseOrders(state, action) {
      state.purchase = action.payload;
    }
  }
});

export const reducer = slice.reducer;

/**
 * getPurchaseOrders
 * @param {*} none
 * @returns  disptach
 */
export const getPurchaseOrders = () => async dispatch => {
  let response = {};
  try {
    response = await axios.get(
      `${apiBaseURL}/api/v1/purchases`
    );
    console.log('[Slice: Purchase] - (getPurchaseOrders) - response',response);
  } catch (error) {
    console.error(error);
  }

  //now we run the dispatch stages
    if (response.status === 200) {
      dispatch(
        slice.actions.setPurchaseOrders(response.data.purchaseOrders)
      );
  }
};
